import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';

import { FieldWrapper, Field, LabelWrapper, SubTextWrapper } from './table_field.styled';
import { whenSideBySide, assignFormDesignToCSSVars } from '../fields-customise.style';
import { MainfieldWrapper, ValidationWarning } from '../../common-field-styles';
import { FormContext } from '../../../shared/contexts/form-context';
import TableFieldSubComponent from './table_sub_component';
import { ControlPropType } from '../../ctrl_proptype';

const TableField = ({ ctrl, formDesign }) => {
  const { inBuilder } = useContext(FormContext);
  const [ctrlValidationError, setCtrlValidationError] = useState(ctrl._validationError);

  useEffect(() => {
    setCtrlValidationError(ctrl._validationError);
  }, [ctrl._validationError]);

  return (
    <MainfieldWrapper style={assignFormDesignToCSSVars(inBuilder, formDesign)}>
      <FieldWrapper>
        {inBuilder && ctrlValidationError && (
          <ValidationWarning className="ui bottom pointing basic label red">{ctrlValidationError}</ValidationWarning>
        )}

        <Field className={!inBuilder ? whenSideBySide(ctrl, formDesign) : ''}>
          <LabelWrapper notInBuilder={!inBuilder} className={!inBuilder ? whenSideBySide(ctrl, formDesign) : ''}>
            {ctrl.props.label}
          </LabelWrapper>

          <TableFieldSubComponent ctrl={ctrl} formDesign={formDesign} />

          <SubTextWrapper notInBuilder={!inBuilder}>{ctrl.props.subtext}</SubTextWrapper>
        </Field>
      </FieldWrapper>
    </MainfieldWrapper>
  );
};

export default TableField;

TableField.defaultProps = {
  formDesign: null,
};

TableField.propTypes = {
  ctrl: PropTypes.shape(ControlPropType).isRequired,
  formDesign: PropTypes.shape({
    old: PropTypes.object.isRequired,
    design: PropTypes.object.isRequired,
  }),
};
